import { IHttpService, IScope } from "angular";
import {LogBookRootScopeService} from "../shared/model/app.model";

angular.module('logbook')
	.controller('validation-required', ['$scope', '$rootScope', '$http',
		function($scope: IScope, $rootScope: LogBookRootScopeService, $http: IHttpService) {
			$rootScope.authenticate();

			$scope.resendWelcomeEmail = () => {
				console.log('resend');

				$http.post('api/welcomeEmail', null).then(() => $scope.resent = true);
			}
		}
	]);